import { render, staticRenderFns } from "./ItemsFeeAdd.vue?vue&type=template&id=1939b5fa&scoped=true&"
import script from "./ItemsFeeAdd.vue?vue&type=script&lang=ts&"
export * from "./ItemsFeeAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsFeeAdd.vue?vue&type=style&index=0&id=1939b5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1939b5fa",
  null
  
)

export default component.exports